import React, { Component, Fragment } from 'react';
import MaterialTableComponent from '../../../src/utils/MaterialTable';
import atErrorCodes from '../../../src/data/at_error_codes';
import spritesheet from '../../icons/spritesheet-simbologia.png';
import style from './style';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';

import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import Footer from '../../layouts/Dashboard/components/Footer/index';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
import { getQueryParams } from '../../utils/fns/get-query-params';
import { withTranslation } from 'react-i18next';

class Symbology extends Component {
  constructor(props) {
    super(props);
    var searchText = "Búsqueda"
    const { t } = this.props;
    const translateAtErrorCodes = [...atErrorCodes].map(item => {
      return {
        ...item,
        nombre: t(`codes.${item.id}.name`),
        descripcion: t(`codes.${item.id}.description`),
      }
    })
    this.state = {
      keys: [{"title":t('simbology.table.header.name'),"field":"nombre", "headerStyle": {"paddingLeft": "50px", "fontSize": "16px"}, "cellStyle": {"fontFamily": "Roboto", "fontWeight": "bold","fontSize": "14px", "paddingLeft": "50px"}},
      {"title":t('simbology.table.header.code'), "field":"id", "headerStyle": {"fontSize": "16px"}, "cellStyle": {"fontSize": "14px", "fontFamily": "Roboto", "fontWeight": "bold"}},
      { "title": t('simbology.table.header.icon'), "field": "posicion", "headerStyle": {"fontSize": "16px"}, "cellStyle": {"fontSize": "14px", "fontFamily": "Roboto"}},
      {"title":t('simbology.table.header.description'),"field":"descripcion", "headerStyle": {"fontSize": "16px"}, "cellStyle": {"fontSize": "14px", "fontFamily": "Roboto"}},
      {"title":t('simbology.table.header.service'),"field":"servicio", "headerStyle": {"fontSize": "16px"}, "cellStyle": {"fontSize": "14px", "fontFamily": "Roboto"}},
      ],
      rows: translateAtErrorCodes
    }
  }

  componentWillMount(){
    this.addIcon()
  }

  addIcon=()=>{
    var rowsNew=[]
    this.state.rows.map(ele=>{
      var codeIcon = <i style={{backgroundImage: `url(${ spritesheet })`, backgroundRepeat: 'no-repeat', display: 'block', width: '286px', height: '252px', backgroundPosition: ele.posicion, zoom: '30%', scale:"0.9", transform:'scale(0.8)'}}></i>
      
      ele["posicion"]=codeIcon
      
      rowsNew.push(ele)
    })
    rowsNew.push({cellStyle: {backgroundColor: '#000',color: 'red'},headerStyle: {backgroundColor: '#039be5',}})
    this.setState({
      rows:rowsNew
    })
  }

	render() {
    const { keys, rows } = this.state
    const { t } = this.props;
    return (
      <Portlet style={{backgroundColor:"#0b1738"}}>
        <PortletHeader style={{borderRadius: '0px'}}>
        <div style={{
            display: 'flex',
            alignItems: 'left'
        }}>
            <NavLink to={{pathname: '/support', search: getQueryParams()}}>
            <Button color='primary'>
                {t('simbology.button.back')}
            </Button>
            </NavLink>
        </div>
        <Typography
            style={{fontWeight: 500, fontFamily: 'Roboto', color: "white"}}
            variant="h3"
          >
            {t('simbology.title')}
          </Typography>
          <a href="https://reporte.atentus.com">
            <img
              alt="Atentus logo"
              src="/images/logos/logo-atentus-gris.svg"
              height="50px"
            />
          </a>
        </PortletHeader>
        <MaterialTableComponent
          rowsForPage={rows.length} 
          changeTittle={""}
          colorSearch={'#FF8B32'}
          keys={keys} 
          data={rows}
          //searchText={searchText}
          paging={false}
          grouping={false}
          />          
        <Footer marginTop={'0px'}/>
      </Portlet>
    );
  }
}

export default compose( withStyles(style), withTranslation()) (Symbology);